import React, { useState } from "react";
import ReactSlider from "react-slider";

const RangeSlider = ({ title, min, max, step, formatLabel, handleFilterChange }) => {
  const [range, setRange] = useState([min, max / 2]); // Default to half of max

  // Handle slider change (dual handle)
  const handleSliderChange = (value) => {
    setRange(value);
    handleFilterChange(value,'price_range') // Send range to parent if needed
  };

  return (
    <div className="range-slider-container mt-1 mb-3 p-2">
      <h5>{title}</h5>
      <label style={{ color: "#343434" }} className="d-flex justify-content-between">
        <span>{formatLabel(range[0])}</span>
        <span>{formatLabel(range[1])}</span>
      </label>

      <ReactSlider
        className="horizontal-slider"
        thumbClassName="thumb"
        trackClassName="track"
        value={range} // Dual handle range
        onChange={handleSliderChange} // Handle range change
        min={min}
        max={max}
        step={step}
        minDistance={step * 10} // Ensures minimum gap
        pearling
        withTracks
      />
    </div>
  );
};

export default RangeSlider;
